module.exports = __webpack_public_path__ + "img/yebao-logo.979d552f.png";